/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import * as _ from 'lodash'
import menus from '@views/PrimaryLayout/menu'
import { isAccountForTesting, loadOrReload } from '@utils/utils'
import useRootStore from '@store/useRootStore'
// icon
import sCashBtn from '@assets/images/btn/scash-btn.png'
// css
import { Button } from '@styles/button.style'
import { MenuTopItem } from './index.style'
import AdvImg from '@components/AdvImg'
import EventFloatingButton from '@views/Matchup/EventFloatingButton'
import PopupUtils from '@utils/popup-utils'

const UserSiderMenu: React.FC = () => {
  const { authStore, componentStore, routerStore, globalStore, matchupStore, logStore } = useRootStore()
  const { authInfo, userInfo } = authStore
  const { nick = 'Unknown' } = userInfo

  // const jobName = job === 2 ? '오즈' : '베터'
  const isTestAccount = isAccountForTesting(userInfo?.id || '')

  const onClickCashChargeButton = () => {
    logStore.writeButtonLog({ pageId: 'd010', buttonId: '003' }).catch(console.error)
    globalStore.setVisibleSideBar(false)
    const url = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}/#/auth_login/${authInfo?.authKey}/payment`
    globalStore.toMoveWebHomePage(url, 'self')
  }

  let isExecuteInitCoupon = true
  if (isMobile) {
    const path = routerStore.location.pathname
    const couponInput = _.find(menus, { namespace: 'coupon' })
    const couponCheck = _.find(menus, { namespace: 'coupon-check' })
    if (path === couponInput.path || path === couponCheck.path) {
      isExecuteInitCoupon = false
    }
  }

  if (isExecuteInitCoupon) {
    componentStore.initCouponIdsVanillaTextAndCouponRegisterInfo()
  }

  let profileImg = null
  if (authStore.signedin === true) {
    if (userInfo) {
      profileImg = (
        <span className={userInfo.customProfileImg ? 'profile-img custom' : 'profile-img'}>
          {userInfo.customProfileImg ?
            (<AdvImg src={userInfo.avatar} srcMode={'small'} alt="사진첩 이미지" className="custom-img"/>)
            :
            (<AdvImg src={userInfo.avatar} srcMode={'small'} alt="스킨" />)
          }
        </span>
      )
    }
  }

  const closeMatchFilter = () => {
    matchupStore.resetTournamentFilterList()
    globalStore.setVisibleMatchFilterPopup(false)
  }

  const closeMatchupDetail = () => {
    globalStore.setVisibleMatchupDetailPopup(false)
  }

  const onClickMyInfoHandler = () => {
    logStore.writeButtonLog({ pageId: 'd010', buttonId: '004' }).catch(console.error)
    if (isMobile) {
      loadOrReload('/my-info')
      closeMatchFilter()
      closeMatchupDetail()
      globalStore.resetGeneralPopupProperties()
      globalStore.setVisibleSideBar(false)
    } else {
      PopupUtils.showMyPagePopup()
      globalStore.setVisibleSideBar(false)
    }
  }

  return (
    <Fragment>
      <MenuTopItem>
        <Button TP className="my-info-btn" onClick={onClickMyInfoHandler}>
          {profileImg}
          <div className="user-info">
            <h3 className="nickname">{nick}</h3>
            <p className="more-info">정보 더보기 <span className="arrow-ico"/></p>
          </div>
        </Button>

        <EventFloatingButton className="menu"/>

        {!isMobile ?
          <div className="pc-btn-wrap">
            {!isTestAccount &&
              <Button TP className="charge-btn" onClick={onClickCashChargeButton}>
                <img src={sCashBtn} alt="S캐시 충전 버튼 PC"/>
              </Button>
            }
          </div> :
          <Fragment>
            {!isTestAccount &&
              <Button TP className="charge-btn" onClick={onClickCashChargeButton}>
                <img src={sCashBtn} alt="S캐시 충전 버튼 Mobile"/>
              </Button>
            }
          </Fragment>
        }

        {isTestAccount && <div className="charge-btn"/>}
      </MenuTopItem>
    </Fragment>
  )
}

export default observer(UserSiderMenu)
